import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import { User } from '@gik/core/models/gik/User';
import moment from 'moment';

export default function userHasSeenInkindTourForThisPage(user: User, inkindPage: InkindPageAPIModel) {
  const welcomeScreenLastSeen = user?.welcomeScreenLastSeen ? moment(user.welcomeScreenLastSeen) : null;
  return welcomeScreenLastSeen && inkindPage && welcomeScreenLastSeen.isAfter(moment.utc(inkindPage.createdUtc));
}
